import React, { useRef } from "react";

const AddTagsForm = ({ tags, setTags }) => {
  const tagRef = useRef();

  const handleSubmit = e => {
    e.preventDefault();
    const tag = tagRef.current.value;

    setTags(prevState => [...prevState, tag]);

    e.target.reset();
  };

  return (
    <>
      <div className="container__tag--margin">
        <form onSubmit={handleSubmit}>
          <input
            className="input__tag"
            type="text"
            placeholder="Add a tag"
            ref={tagRef}
          />
        </form>
      </div>
    </>
  );
};

export default AddTagsForm;
